import { render, staticRenderFns } from "./AddGoodsDialog.vue?vue&type=template&id=29bb46df&scoped=true&"
import script from "./AddGoodsDialog.vue?vue&type=script&setup=true&lang=js&"
export * from "./AddGoodsDialog.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AddGoodsDialog.vue?vue&type=style&index=0&id=29bb46df&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.10.2_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17._qkvgvrmvpkafkn37suro37nope/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bb46df",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/web_gys_admin_online_docker/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29bb46df')) {
      api.createRecord('29bb46df', component.options)
    } else {
      api.reload('29bb46df', component.options)
    }
    module.hot.accept("./AddGoodsDialog.vue?vue&type=template&id=29bb46df&scoped=true&", function () {
      api.rerender('29bb46df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/nb/supplyChain/goods/components/AddGoodsDialog.vue"
export default component.exports